/*
  Export to excel library reference
  https://github.com/guyonroche/exceljs
  https://www.npmjs.com/package/exceljs
 */
import { Injectable, Optional } from '@angular/core';
import * as Excel from 'exceljs/dist/exceljs';
import { Workbook, Worksheet } from 'exceljs';
import * as FileSaver from 'file-saver';
import {
  WorkBookConfig,
  AddWorkSheet,
  AddColumn
} from '../../shared/models/export-excel';

@Injectable()
export class ExportExcelService {
  /***************Constructor***************/
  constructor() {}
  /***************Constructor***************/

  /***************Helper Methods***************/

  createWorkbook(
    @Optional() worksheets: Array<AddWorkSheet> = [],
    @Optional() config: WorkBookConfig = null
  ) {
    const workbook: Workbook = new Excel.Workbook();

    workbook.created = config && config.created ? config.created : new Date();
    workbook.modified =
      config && config.modified ? config.modified : new Date();
    workbook.lastPrinted =
      config && config.lastPrinted ? config.lastPrinted : new Date();
    workbook.creator = config && config.creator ? config.creator : 'ParMed Web';
    workbook.lastModifiedBy =
      config && config.lastModifiedBy ? config.lastModifiedBy : 'ParMed Web';
    workbook.properties =
      config && config.properties ? config.properties : workbook.properties;

    if (worksheets.length > 0) {
      worksheets.forEach(worksheet => {
        this.addWorkSheet(workbook, worksheet);
      });
    }

    return workbook;
  }

  addWorkSheet(workbook: Workbook, worksheet: AddWorkSheet) {
    const sheet = workbook.addWorksheet(worksheet.name, worksheet.options);

    if (worksheet.columns) {
      this.addColumns(sheet, {
        columns: worksheet.columns,
        columnConfig: worksheet.columnConfig,
        style: worksheet.style
      });
    }

    if (worksheet.rows) {
      this.addRows(sheet, worksheet.rows);
    }

    return sheet;
  }

  addColumns(worksheet: Worksheet, sheetColumn: AddColumn): void {
    if (sheetColumn.columns.length > 0) {
      const columnHeaders: string[] = [];
      const columnKeys: any[] = [];
      sheetColumn.columns.forEach(col => {
        columnKeys.push({ key: col.key.toString() });
        columnHeaders.push(col.header.toString());
      });

      worksheet.columns = columnKeys;

      const colRow = worksheet.addRow(columnHeaders);
      colRow.font = { bold: sheetColumn.columnConfig.bold };

      sheetColumn.columns.forEach(col => {
        const column = worksheet.getColumn(col.key.toString());
        column.width = col.width || column.width;
        column.style = Object.assign(column.style, col.style);
      });
    }
  }

  addRows(worksheet: Worksheet, rows: Array<any>) {
    worksheet.addRows(rows);
  }

  export(
    workbook: Workbook,
    fileName: string,
    extension: string = 'xlsx',
    type = 'application/octet-stream'
  ) {
    workbook.xlsx.writeBuffer().then(function(buffer: ArrayBuffer) {
      const data: Blob = new Blob([buffer], {
        type: type
      });
      FileSaver.saveAs(data, fileName + '.' + extension);
    });
  }

  /***************Helper Methods***************/
}
